import { makeAutoObservable, flow } from 'mobx';
import { zhCNStr } from '@/constants';
import { postLogout } from '@/api/Dialogs/signUpDlg';
import { getUserInfo } from '@/api/Dialogs/signUpDlg';
import { createProject } from '@/api/landingPage';
import { getVipInfo } from '&/api/personCenter/projectSpace';

const TOKEN_KEY = 'hdcToken';
const INFO_KEY = 'hdcUserInfo';
const WCP_TOKEN_KEY = 'hdcWcpToken';
const WCP_FLAG = 'isWcp';
const REMEMBER_ME = 'rememberMe';
const SKIP_NOTE_DWG = 'skiNoteDWG';

class AppStore {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    useLocalStorage = localStorage.getItem(REMEMBER_ME) || false;

    lang = this.getStorageMode().getItem('hdcLang') || zhCNStr;

    userInfo = JSON.parse(this.getStorageMode().getItem(INFO_KEY)) || {};

    isWcp = JSON.parse(this.getStorageMode().getItem(WCP_FLAG));

    token = this.isWcp
        ? this.getStorageMode().getItem(WCP_TOKEN_KEY)
        : this.getStorageMode().getItem(TOKEN_KEY);

    isTabletLandingPage = false;

    noteDwg = this.getStorageMode().getItem(SKIP_NOTE_DWG) || false;

    getStorageMode() {
        const parsedVal = JSON.parse(this.useLocalStorage);
        return parsedVal ? localStorage : sessionStorage;
    }

    rememberMe(checked) {
        if (checked !== undefined) {
            this.useLocalStorage = checked;
            localStorage.setItem(REMEMBER_ME, checked);
        }
    }

    skipNoteDwg(checked) {
        this.noteDwg = checked;
        this.getStorageMode().setItem(SKIP_NOTE_DWG, checked);
    }

    changeLang(lang) {
        this.lang = lang;
    }

    setToken(str, isWcp) {
        if (!str) return;
        this.token = str;
        this.isWcp = isWcp;
        this.getStorageMode().setItem(WCP_FLAG, isWcp);
        this.getStorageMode().setItem(isWcp ? WCP_TOKEN_KEY : TOKEN_KEY, str);
    }

    removeToken() {
        this.token = null;
        this.getStorageMode().removeItem(TOKEN_KEY);
        this.getStorageMode().removeItem(WCP_TOKEN_KEY);
    }

    get isLogIn() {
        return !!this.token;
    }

    queryUserInfo = flow(function* () {
        if (!this.isLogIn) return;
        const { data = {} } = yield getUserInfo();
        this.setUserInfo(data);
    });

    setUserInfo(obj = {}) {
        this.userInfo = obj;
        this.getStorageMode().setItem(INFO_KEY, JSON.stringify(obj));
    }

    removeUserInfo() {
        this.userInfo = {};
        this.getStorageMode().removeItem(INFO_KEY);
    }

    setLoginData(data, isWcp) {
        this.setToken(data.token, isWcp);
        this.setUserInfo(data.userinfo);
    }
    setBusinessLoginData(data, isWcp) {
        this.getStorageMode().setItem('hdcBusinessToken', data.token);
        this.getStorageMode().setItem(
            'hdcBusinessUserInfo',
            JSON.stringify(data.userinfo)
        );
        localStorage.setItem('rememberMeBusiness', this.useLocalStorage);
    }
    setOrganization(obj = {}) {
        this.getStorageMode().setItem('organization', JSON.stringify(obj));
        localStorage.setItem('organization', JSON.stringify(obj));
    }
    async logout() {
        const { code } = await postLogout();
        if (code !== 0) return Promise.reject();
        this.clearLoginData();
        window.location.reload();
        return Promise.resolve();
    }
    clearLoginData() {
        this.removeUserInfo();
        this.removeToken();
    }

    isShowSignUpDlg = false; // 是否显示注册对话框

    isShowSignInDlg = false; // 是否显示登录对话框

    isShowApplyTrialDlg = false; // 是否显示申请试用对话框

    setSignUpDlgVisable(visable) {
        this.isShowSignUpDlg = visable;
        this.isShowSignInDlg = !visable;
        this.isShowApplyTrialDlg = !visable;
    }
    setApplyTrialDlgVisible(visable) {
        this.isShowApplyTrialDlg = visable;
        this.isShowSignInDlg = !visable;
        this.isShowSignUpDlg = !visable;
    }
    setSignInDlgVisable(visable) {
        this.isShowSignInDlg = visable;
        this.isShowSignUpDlg = !visable;
        this.isShowApplyTrialDlg = !visable;
    }
    // type = SignIn | SignUp
    setModalVisible(type, bool) {
        this[`isShow${type}Dlg`] = bool;
    }

    closeAllDlg() {
        this.isShowSignInDlg = false;
        this.isShowSignUpDlg = false;
    }

    isHideHeader = false; //是否显示header 上的路由和登录

    setHeaderHide(hide) {
        this.isHideHeader = hide;
    }

    setPDFviwer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }

    getPDFviwer() {
        return this.pdfViewer;
    }

    isFreeUseLogin = false;

    isAiLogin = false;

    setIsFreeUseLogin(flag) {
        this.isFreeUseLogin = flag;
    }

    setIsFromAI(flag) {
        this.isAiLogin = flag;
    }

    handleFreeUse(targetPage) {
        if (this.isLogIn) {
            createProject()
                .then(() => {
                    const pathname = '/user-center/project-space';
                    const isReload = window.location.pathname === pathname;
                    if (isReload) {
                        window.location.reload();
                    } else {
                        targetPage({ pathname });
                    }
                })
                .catch(err => {
                    Promise.reject(err);
                });
        } else {
            targetPage({
                pathname: `/login/signin`,
            });
            this.setIsFreeUseLogin(true);
        }
    }

    isNeedMobile = false;
    setIsNeedMobile(bool) {
        this.isNeedMobile = bool;
    }

    isPdfChange = false;

    setIsPdfChange(flag) {
        this.isPdfChange = flag;
    }

    vipDuration = -1;

    getVipInfo() {
        return getVipInfo().then(res => {
            if (
                res.data &&
                (res.data.surplusDuration || res.data.surplusDuration === 0)
            ) {
                this.vipDuration = res.data.surplusDuration;
            }
        });
    }
}

const appStore = new AppStore();

export default appStore;
